import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import NotificationModal from "./NotificationModal";

const NotificationDisplay: React.FC = () => {
  const { isOpen, notification } = useSelector((state: RootState) => state.notificationModal);

  if (!isOpen || !notification) return null;

  return <NotificationModal />;
};

export default NotificationDisplay;
